"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_UPDATE = exports.EVENT_DID_RESET = exports.EVENT_WILL_RESET = exports.EVENT_DID_REPLACE = exports.EVENT_WILL_REPLACE = exports.EVENT_DID_POP = exports.EVENT_WILL_POP = exports.EVENT_DID_PUSH = exports.EVENT_WILL_PUSH = exports.ACTION_UPDATE = exports.ACTION_RESET = exports.ACTION_REPLACE = exports.ACTION_POP = exports.ACTION_PUSH = void 0;
var ACTION_PUSH = 'PUSH';
exports.ACTION_PUSH = ACTION_PUSH;
var ACTION_POP = 'POP';
exports.ACTION_POP = ACTION_POP;
var ACTION_REPLACE = 'REPLACE';
exports.ACTION_REPLACE = ACTION_REPLACE;
var ACTION_RESET = 'RESET';
exports.ACTION_RESET = ACTION_RESET;
var ACTION_UPDATE = 'UPDATE';
exports.ACTION_UPDATE = ACTION_UPDATE;
var EVENT_WILL_PUSH = 'router.willPush';
exports.EVENT_WILL_PUSH = EVENT_WILL_PUSH;
var EVENT_DID_PUSH = 'router.didPush';
exports.EVENT_DID_PUSH = EVENT_DID_PUSH;
var EVENT_WILL_POP = 'router.willPop';
exports.EVENT_WILL_POP = EVENT_WILL_POP;
var EVENT_DID_POP = 'router.didPop';
exports.EVENT_DID_POP = EVENT_DID_POP;
var EVENT_WILL_REPLACE = 'router.willReplace';
exports.EVENT_WILL_REPLACE = EVENT_WILL_REPLACE;
var EVENT_DID_REPLACE = 'router.didReplace';
exports.EVENT_DID_REPLACE = EVENT_DID_REPLACE;
var EVENT_WILL_RESET = 'router.willReset';
exports.EVENT_WILL_RESET = EVENT_WILL_RESET;
var EVENT_DID_RESET = 'router.didReset';
exports.EVENT_DID_RESET = EVENT_DID_RESET;
var EVENT_UPDATE = 'router.update';
exports.EVENT_UPDATE = EVENT_UPDATE;